import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// reactstrap components
import {Button,Card,CardBody,Form,Input,Row,Col,Container} from "reactstrap";

// style
import "assets/css/loading.css";

// services
import { showMessage } from "services/message.js";
import { api_POST, api_GET } from "services/api_service.js";
import { getSessionCookie } from "services/session";

export default function Declaracao({item, handleFinalizarCadastro, handleStepAnterior}) {
    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });
    
    const [showLoading, setshowLoading] = React.useState(false);
    
    const [requerimento, set_requerimento] = React.useState(null);

    const [declaracao, set_declaracao] = React.useState("");

    const session = getSessionCookie();

    useEffect(() => {
        set_requerimento(item);
        api_GET('setupsolicitacao/GetByAcaoId/' + item.setupSolicitacaoAcao_Id).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else{
                set_declaracao(result.data.descricaoDeclaracao);
            }
        });
    }, []);

    const onSubmit = (data) => {
        if (data.checkDeclaracao != true){
            showMessage("Aviso", "Você não pode confirmar o cadastro sem aceitar a declaração!", 'error' , null);            
            return;
        }

        let json_submit = requerimento;
        json_submit.protocolo = null;
        json_submit.textoDeclaracao = declaracao;
                
        setshowLoading(true);
        api_POST('requerimento/PostConfirmarDeclaracao ',json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200)
                showMessage("Aviso", result.message, 'error' , null);
            else{                                   
                showMessage("Aviso", "Seu cadastro foi concluído e será analisado por " + localStorage.getItem("roc-identificacao") + ". Você receberá todas as informações por email.", 'success' , function(){
                    handleFinalizarCadastro(requerimento);
                });                
            }           
        });        
    }
    
    return (
<>
    {showLoading && 
        <div className="carregandoCmp">
            <div className="box">                
                <img src={require("assets/img/loading.gif")}></img>
            </div>
        </div> 
    }
    <div>
        <Card className={`card card-stats`}>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <h2 className="titulo-solicitacao">Declaração </h2>                        
                    <Container style={{maxWidth:"1000px",margin:"0px auto"}}>
                        <Row>
                            <Col md="12">
                                <Input type="checkbox" name="checkDeclaracao" innerRef={register({ required: true})} />{declaracao}
                                <span className="form-check-sign">
                                    <span className="check"></span>
                                </span>                                
                            </Col>
                            <Col md="6">
                                <Button color="secundary" onClick={() => handleStepAnterior(requerimento)} className="btn-mobile" type="button"><i className="fas fa-chevron-left"></i> Voltar</Button>                            
                            </Col>                            
                            <Col md="6" className="text-right">
                                <Button color="success" className="btn-mobile" type="submit">Confirmar Declaração <i className="fas fa-check"></i></Button>
                            </Col>
                        </Row>                                                                       
                    </Container>                        
                </Form>
            </CardBody>
        </Card>
    </div>
</>
    );
}           